import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "wrapper my-4 py-5 pb-10 md:pb-0" }
const _hoisted_2 = { class: "rounded my-2 lg:rounded-2xl lg:shadow-xs drop-shadow-sm" }
const _hoisted_3 = { class: "max-w-sm mx-auto" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "my-7 w-full px-5 h-[150px] bg-gray-300 dark:bg-gray-800 animate-pulse rounded-lg flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-10 h-10 text-gray-100 dark:text-gray-600",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 20"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" })
  ])
], -1)
const _hoisted_7 = {
  for: "upload-image",
  class: "my-3 titleFont block cursor-pointer text-center transition-colors duration-150 px-5 py-2 rounded-lg w-full bg-primary-300 text-white hover:bg-primary-400 active:bg-primary-500 focus:bg-primary-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueCropper = _resolveComponent("VueCropper")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.img)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_VueCropper, {
                ref: "cropper",
                src: _ctx.img.url,
                alt: "Source Image",
                containerStyle: [{height: '250px'}, _ctx.p_events],
                aspectRatio: 1,
                initialAspectRatio: 1,
                disabled: ""
              }, null, 8, ["src", "containerStyle"]),
              _createVNode(_component_Button, {
                onClick: _ctx.upload,
                class: "my-3"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Save')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_Button, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.img = null)),
                "gray-theme": true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Reset')), 1)
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("form", null, [
                _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('Upload')), 1),
                _createElementVNode("input", {
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
                  id: "upload-image",
                  type: "file",
                  accept: "image/jpeg,image/png,image/webp",
                  hidden: ""
                }, null, 32)
              ])
            ]))
      ])
    ])
  ]))
}